<div>
    <h1>
        Please enter more information about this case
        <br />
        Case title: {{ caseModel.title }}
    </h1>
    <h3 class="my-3">Please enter the following information:</h3>
    <v-form ref="form" @submit.prevent="submit">
        <div class="mb-3">
            <label class="d-block mb-1">
                Please upload the final answer that was sent to the customer as
                .pdf, .doc or .msg file.*
            </label>
            <v-file-input
                truncate-length="15"
                v-model="solveData.file"
                variant="outlined"
                density="compact"
                placeholder="Upload a file"
                accept=".doc,.docx,.pdf,.msg"
                :rules="[(v) => !!v]"
                hide-details></v-file-input>
        </div>
        <div class="mb-3" v-if="isBoardCase">
            <label class="d-block mb-1">
                Date of final reply to the customer: *
            </label>
            <DatePicker
                v-model="solveData.finalReplyDate"
                :required-field="true"
                hide-details
                density="compact"
                placeholder="Select date of the final reply"></DatePicker>
        </div>
        <div class="mb-3" v-if="isBoardCase">
            <label class="d-block mb-1">Sorry activity?</label>
            <v-switch v-model="solveData.sorryActivity" hide-details></v-switch>
        </div>
        <div class="mb-3" v-if="isBoardCase">
            <label class="d-block mb-1">Did you call the customer?</label>
            <v-switch
                v-model="solveData.contactedViaPhone"
                hide-details></v-switch>
        </div>
        <div class="mb-3" v-if="isBoardCase">
            <label class="d-block mb-1">
                NSC Case ID and/or Case Queue Name:
            </label>
            <v-text-field
                v-model="solveData.nscCaseId"
                placeholder="NSC Case ID"
                variant="outlined"
                density="compact"
                hide-details></v-text-field>
        </div>
        <div class="mb-3">
            <label class="d-block mb-1">VIN#: *</label>
            <v-text-field
                v-model="solveData.vin"
                placeholder="VIN"
                :rules="[(v) => !!v]"
                variant="outlined"
                density="compact"></v-text-field>
        </div>
        <div class="mb-3">
            <br />
            <div class="mb-2">
                Each code level set must be coded with at least one solution.
            </div>
            <br />
            <CaseSolutionInput
                :caseModel="caseModel"
                v-model:solutions="solveData.solutions" />
        </div>
        <div class="d-flex mt-4 justify-end">
            <BaseButton :width="200" submit :disabled="loading">
                Submit
            </BaseButton>
        </div>
    </v-form>
    <NotificationDialog
        v-model:visible="validationErrorVisible"
        title="Validation Error!"
        message="At least one solution must be specified for each set of code levels, and all required fields for the solution must be completed." />
</div>
